import type { BreakdownDay } from '../types';

/**
 * v3-parity step-2 — a pricing.breakdownDays típus-szerinti aggregálása a
 * napi/heti bontás-panel megjelenítéséhez. NEM számol árat (az a pricing dolga),
 * csak a már-kész napi bontást összegzi típusonként.
 */
export interface BreakdownSummary {
  workdays: number;
  sundays: number;
  holidays: number;
  total: number;
}

export function summarizeBreakdownDays(days: BreakdownDay[]): BreakdownSummary {
  const summary: BreakdownSummary = { workdays: 0, sundays: 0, holidays: 0, total: days.length };
  for (const d of days) {
    if (d.type === 'WORKDAY') summary.workdays++;
    else if (d.type === 'SUNDAY') summary.sundays++;
    else if (d.type === 'HOLIDAY') summary.holidays++;
  }
  return summary;
}
